module.exports = __webpack_public_path__ + "static/img/emt_example_payment4.24b8710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emt_example_payment4.jpg
// module id = RdWo
// module chunks = 0